import Page from '../../page';
import SimpleSharePopin from '../../../helpers/simple-share-popin';

export default class NewsEntry extends Page {
    constructor(...args) {
        super(...args);

        this._retrieveDOM();
        this._initTls();
    }

    _retrieveDOM() {
        this.dom.views = {};

        this.dom.views.socials = this.dom.page.querySelectorAll('[data-social]');
    }

    init() {
        super.init();

        new SimpleSharePopin(this.dom.views.socials);
    }

    /**
     * init() {}
     * bind() {}
     * unbind() {}
     * resize(width, height) {}
     * _destroy() {}
     */
}



// WEBPACK FOOTER //
// ./src/js/pages/news/entry/news-entry.js